<template>
	<BaseContenedor>
		<BaseBuscar v-model="filter">
			<BaseButton
				v-puede-disabled="[roles.Administrador]"
				:disabled="aspirantes.length === 0"
				style-button="danger"
				style-class="right floated"
				@click="onEliminarTodos"
			>
				<i class="trash icon"></i>
				Eliminar
			</BaseButton>
			<BaseButton
				v-puede-disabled="[roles.Administrador, roles.Personal]"
				style-button="primary"
				style-class="right floated"
				@click="toggleModalArchivo"
			>
				<i class="plus icon"></i>
				Importar
			</BaseButton>
		</BaseBuscar>

		<BaseModalArchivo
			ref="modal-archivo"
			v-model="files"
			titulo="Importar Aspirantes"
			plantilla-descripcion="Descargue el formato CSV para agregar nuevas asociaciones aspirantes al personal."
			:plantilla="plantilla"
			:loading="getLoadingAction"
			@close="toggleModalArchivo"
			@aceptar="subirArchivoCsv"
		></BaseModalArchivo>
		<BaseTabla
			ref="table"
			:campos="campos"
			:elementos="aspirantes"
			:pagina-actual="paginaActual"
			:loading="getLoading"
			:filtro="filter"
			actions
			sin-detalle
			@cambiarPagina="cambiarPagina"
		>
			<template slot="action" slot-scope="{ item }">
				<div @click.stop>
					<i
						class="icon iconAction trash alternate"
						title="Eliminar asociación"
						@click="eliminar(item)"
					></i>
				</div>
			</template>
			<template slot="EMPTY">Sin aspirantes asociados</template>
		</BaseTabla>
	</BaseContenedor>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Vue from 'vue';
import Notification from '@utils/notification';
import Rols from '@constants/roles';

export default {
	page: {
		title: 'Personal - Aspirantes',
		meta: [{ name: 'description', content: 'The Personal page.' }]
	},
	data: function() {
		return {
			paginaActual: 1,
			elemento: null,
			files: [],
			campos: {
				ficha: { nombre: 'Ficha', class: 'six wide' },
				nombreCompleto: { nombre: 'Nombre completo', class: 'teen wide' }
			},
			filter: '',
			roles: Rols
		};
	},
	computed: {
		...mapGetters('personal', [
			'getAspirantes',
			'getPersona',
			'getLoading',
			'getLoadingAction'
		]),
		...mapGetters('plantillas', ['getPlantillas']),
		...mapGetters('oidc', ['oidcUser']),
		plantilla: function() {
			return this.getPlantillas.CAT_PERSONAL_ASPIRANTES;
		},
		aspirantes: function() {
			return this.getAspirantes.map(({ plantel, ficha, nombreCompleto }) => ({
				plantel,
				ficha,
				nombreCompleto
			}));
		}
	},
	watch: {
		filter: function(value) {
			this.$refs.table.ocultarElemento();
			if (this.paginaActual !== 1) this.paginaActual = 1;
		},
		getLoadingAction: function(value, old) {
			this.$confirm(null, value);
		}
	},
	mounted() {
		this.establecerUrlAtras(
			this.oidcUser.rol === this.roles.Administrador
				? '/catalogos/personal'
				: '/inicio'
		);
		if (this.$route.params.clavePersonal) {
			this.obtenerPersona({
				clavePersonal: this.$route.params.clavePersonal,
				onComplete: (response) => {
					this.obtenerAspirantes({
						clavePersonal: this.$route.params.clavePersonal
					});
					this.establecerTitulo(
						`Aspirantes de ${response.data.data.nombreCompleto}`
					);
				}
			});
		}
	},
	methods: {
		...mapActions('personal', [
			'obtenerPersona',
			'establecerPersona',
			'eliminarTodosAspirantes',
			'subirArchivoAspirantesCsv',
			'obtenerAspirantes',
			'eliminarAspirantes'
		]),
		...mapActions('app', ['establecerTitulo', 'establecerUrlAtras']),
		toggleModalArchivo() {
			this.$refs.table.ocultarElemento();
			this.$refs['modal-archivo'].toggle();
		},
		closeModalArchivo() {
			this.$refs['modal-archivo'].close();
		},
		subirArchivoCsv() {
			if (this.files.length > 0) {
				this.cambiarPagina(1);
				this.subirArchivoAspirantesCsv({
					clavePersonal: this.$route.params.clavePersonal,
					archivos: this.files[0],
					onComplete: () => {
						Notification('info', 'Procesando información');
						this.closeModalArchivo();
						setTimeout(() => {
							this.obtenerAspirantes({
								clavePersonal: this.$route.params.clavePersonal
							});
						}, 2000);
					}
				});
				Vue.set(this, 'files', []);
			}
		},
		cambiarPagina(paginaActual) {
			this.paginaActual = paginaActual;
		},
		onEliminarTodos() {
			this.$refs.table.ocultarElemento();
			this.$confirm({
				title: 'Desasociar aspirantes',
				message: '¿Desea desasociar los aspirantes?',
				description: 'Esta opción no se puede deshacer.',
				titleOk: 'Aceptar',
				titleCancel: `Cancelar`,
				callbackOk: (closeModal) => {
					this.eliminarTodosAspirantes({
						clavePersonal: this.$route.params.clavePersonal,
						onComplete: () => {
							setTimeout(() => {
								this.obtenerAspirantes({
									clavePersonal: this.$route.params.clavePersonal
								});
							}, 1000);
							closeModal();
							Notification('success', '¡Aspirantes desasociados con éxito!');
						},
						onError: () =>
							Notification('error', 'Error al desasociar los aspirantes')
					});
				},
				callbackCancelar: () => {}
			});
		},
		eliminar(personal) {
			this.$refs.table.ocultarElemento();
			this.$confirm({
				title: 'Desasociar aspirante',
				message: '¿Desea desasociar el aspirante seleccionado?',
				description: 'Esta opción no se puede deshacer.',
				titleOk: 'Aceptar',
				titleCancel: `Cancelar`,
				callbackOk: (closeModal) => {
					this.eliminarAspirantes({
						clavePersonal: this.$route.params.clavePersonal,
						ficha: personal.ficha,
						onComplete: () => {
							setTimeout(() => {
								this.obtenerAspirantes({
									clavePersonal: this.$route.params.clavePersonal
								});
							}, 1000);
							closeModal();
							Notification('success', '¡Aspirante desasociado con éxito!');
						},
						onError: () =>
							Notification('error', 'Error al desasociar el aspirante')
					});
				},
				callbackCancelar: () => {}
			});
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';
</style>
